function greater(a, b) {
  return a.value < b.value ? 1 : -1;
}

export default {
  'simulation[vehicle][manufacture_year]': greater,
  'simulation[vehicle][model_year]': greater,
};
